import React, { useEffect, useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import dataEngine from "../core/books/data.js";
import "./CourseDetail.css";

// 🔽 CHANGED: curriculum helpers برای تولید COURSE_DETAILS خودکار
import {
  GRADE_LIST,
  FIELD_LIST,
  getSubjectsFor,
  needsField as curriculumNeedsField,
  normalizeGradeId as curriculumNormalizeGrade,
  normalizeFieldId as curriculumNormalizeField,
} from "../core/education/curriculum.js";

// ==================== داده‌های کامل برای تمام دروس (با تصاویر صفحه کتاب‌ها) ====================
export const COURSE_DETAILS = {
  // ===== پایه اول =====
  "1-riazi": {
    grade: "پایه اول",
    title: "ریاضی",
    students: 1245,
    teachers: 8,
    lessons: 24,
    videoHours: 18,
    image: "/Books/riazi-1.jpg",
  },
  "1-olum": {
    grade: "پایه اول",
    title: "علوم",
    students: 1180,
    teachers: 7,
    lessons: 22,
    videoHours: 16,
    image: "/Books/olum-1.jpg",
  },
  "1-ghoran": {
    grade: "پایه اول",
    title: "قرآن",
    students: 1100,
    teachers: 6,
    lessons: 20,
    videoHours: 14,
    image: "/Books/ghoran-1.jpg",
  },
  "1-farsi": {
    grade: "پایه اول",
    title: "فارسی",
    students: 1300,
    teachers: 9,
    lessons: 26,
    videoHours: 20,
    image: "/Books/farsi-1.jpg",
  },

  // ===== پایه دوم =====
  "2-riazi": {
    grade: "پایه دوم",
    title: "ریاضی",
    students: 1320,
    teachers: 9,
    lessons: 26,
    videoHours: 20,
    image: "/Books/riazi-2.jpg",
  },
  "2-olum": {
    grade: "پایه دوم",
    title: "علوم",
    students: 1250,
    teachers: 8,
    lessons: 24,
    videoHours: 18,
    image: "/Books/olum-2.jpg",
  },
  "2-ghoran": {
    grade: "پایه دوم",
    title: "قرآن",
    students: 1150,
    teachers: 7,
    lessons: 22,
    videoHours: 15,
    image: "/Books/ghoran-2.jpg",
  },
  "2-farsi": {
    grade: "پایه دوم",
    title: "فارسی",
    students: 1380,
    teachers: 10,
    lessons: 28,
    videoHours: 22,
    image: "/Books/farsi-2.jpg",
  },
  "2-hedye": {
    grade: "پایه دوم",
    title: "هدیه‌های آسمان",
    students: 1050,
    teachers: 6,
    lessons: 20,
    videoHours: 14,
    image: "/Books/hedye-2.jpg",
  },

  // ===== پایه سوم =====
  "3-riazi": {
    grade: "پایه سوم",
    title: "ریاضی",
    students: 1400,
    teachers: 10,
    lessons: 28,
    videoHours: 22,
    image: "/Books/riazi-3.jpg",
  },
  "3-olum": {
    grade: "پایه سوم",
    title: "علوم",
    students: 1320,
    teachers: 9,
    lessons: 26,
    videoHours: 20,
    image: "/Books/olum-3.jpg",
  },
  "3-ghoran": {
    grade: "پایه سوم",
    title: "قرآن",
    students: 1200,
    teachers: 7,
    lessons: 22,
    videoHours: 16,
    image: "/Books/ghoran-3.jpg",
  },
  "3-farsi": {
    grade: "پایه سوم",
    title: "فارسی",
    students: 1450,
    teachers: 11,
    lessons: 30,
    videoHours: 24,
    image: "/Books/farsi-3.jpg",
  },
  "3-hedye": {
    grade: "پایه سوم",
    title: "هدیه‌های آسمان",
    students: 1100,
    teachers: 6,
    lessons: 20,
    videoHours: 14,
    image: "/Books/hedye-3.jpg",
  },
  "3-motaleat": {
    grade: "پایه سوم",
    title: "مطالعات اجتماعی",
    students: 1150,
    teachers: 7,
    lessons: 22,
    videoHours: 16,
    image: "/Books/motaleat-3.jpg",
  },

  // ===== پایه چهارم =====
  "4-riazi": {
    grade: "پایه چهارم",
    title: "ریاضی",
    students: 1480,
    teachers: 11,
    lessons: 30,
    videoHours: 24,
    image: "/Books/riazi-4.jpg",
  },
  "4-olum": {
    grade: "پایه چهارم",
    title: "علوم",
    students: 1380,
    teachers: 10,
    lessons: 28,
    videoHours: 22,
    image: "/Books/olum-4.jpg",
  },
  "4-ghoran": {
    grade: "پایه چهارم",
    title: "قرآن",
    students: 1250,
    teachers: 8,
    lessons: 24,
    videoHours: 18,
    image: "/Books/ghoran-4.jpg",
  },
  "4-farsi": {
    grade: "پایه چهارم",
    title: "فارسی",
    students: 1520,
    teachers: 12,
    lessons: 32,
    videoHours: 26,
    image: "/Books/farsi-4.jpg",
  },
  "4-hedye": {
    grade: "پایه چهارم",
    title: "هدیه‌های آسمان",
    students: 1150,
    teachers: 7,
    lessons: 22,
    videoHours: 16,
    image: "/Books/hedye-4.jpg",
  },
  "4-motaleat": {
    grade: "پایه چهارم",
    title: "مطالعات اجتماعی",
    students: 1200,
    teachers: 8,
    lessons: 24,
    videoHours: 18,
    image: "/Books/motaleat-4.jpg",
  },

  // ===== پایه پنجم =====
  "5-riazi": {
    grade: "پایه پنجم",
    title: "ریاضی",
    students: 1550,
    teachers: 12,
    lessons: 32,
    videoHours: 26,
    image: "/Books/riazi-5.jpg",
  },
  "5-olum": {
    grade: "پایه پنجم",
    title: "علوم",
    students: 1450,
    teachers: 11,
    lessons: 30,
    videoHours: 24,
    image: "/Books/olum-5.jpg",
  },
  "5-ghoran": {
    grade: "پایه پنجم",
    title: "قرآن",
    students: 1300,
    teachers: 9,
    lessons: 26,
    videoHours: 20,
    image: "/Books/ghoran-5.jpg",
  },
  "5-farsi": {
    grade: "پایه پنجم",
    title: "فارسی",
    students: 1600,
    teachers: 13,
    lessons: 34,
    videoHours: 28,
    image: "/Books/farsi-5.jpg",
  },
  "5-hedye": {
    grade: "پایه پنجم",
    title: "هدیه‌های آسمان",
    students: 1200,
    teachers: 8,
    lessons: 24,
    videoHours: 18,
    image: "/Books/hedye-5.jpg",
  },
  "5-motaleat": {
    grade: "پایه پنجم",
    title: "مطالعات اجتماعی",
    students: 1250,
    teachers: 8,
    lessons: 24,
    videoHours: 18,
    image: "/Books/motaleat-5.jpg",
  },

  // ===== پایه ششم =====
  "6-riazi": {
    grade: "پایه ششم",
    title: "ریاضی",
    students: 1620,
    teachers: 13,
    lessons: 34,
    videoHours: 28,
    image: "/Books/riazi-6.jpg",
  },
  "6-olum": {
    grade: "پایه ششم",
    title: "علوم",
    students: 1520,
    teachers: 12,
    lessons: 32,
    videoHours: 26,
    image: "/Books/olum-6.jpg",
  },
  "6-ghoran": {
    grade: "پایه ششم",
    title: "قرآن",
    students: 1350,
    teachers: 9,
    lessons: 26,
    videoHours: 20,
    image: "/Books/ghoran-6.jpg",
  },
  "6-farsi": {
    grade: "پایه ششم",
    title: "فارسی",
    students: 1680,
    teachers: 14,
    lessons: 36,
    videoHours: 30,
    image: "/Books/farsi-6.jpg",
  },
  "6-hedye": {
    grade: "پایه ششم",
    title: "هدیه‌های آسمان",
    students: 1250,
    teachers: 8,
    lessons: 24,
    videoHours: 18,
    image: "/Books/hedye-6.jpg",
  },
  "6-motaleat": {
    grade: "پایه ششم",
    title: "مطالعات اجتماعی",
    students: 1300,
    teachers: 9,
    lessons: 26,
    videoHours: 20,
    image: "/Books/motaleat-6.jpg",
  },
  "6-tafakor": {
    grade: "پایه ششم",
    title: "تفکر و پژوهش",
    students: 1100,
    teachers: 7,
    lessons: 20,
    videoHours: 14,
    image: "/Books/tafakor-6.jpg",
  },
  "6-kar": {
    grade: "پایه ششم",
    title: "کار و فناوری",
    students: 1080,
    teachers: 6,
    lessons: 18,
    videoHours: 12,
    image: "/Books/kar-6.jpg",
  },
};

// ================================================================
// 🔽 CHANGED: تولید خودکار داده برای پایه‌های ۷-۱۲
// ----------------------------------------------------------------
// • برای ۷-۹: کلید «grade-subject»
// • برای ۱۰-۱۲: کلید «grade-field-subject»
// ----------------------------------------------------------------
// این داده‌ها به‌صورت پیش‌فرض تولید می‌شن و اگه خواستی می‌تونی
// هر کدوم رو دستی با override جایگزین کنی.
// ================================================================

const _DEFAULT_COURSE_META = {
  "7":  { students: 1200, teachers: 8,  lessons: 24, videoHours: 18 },
  "8":  { students: 1250, teachers: 8,  lessons: 26, videoHours: 20 },
  "9":  { students: 1300, teachers: 9,  lessons: 28, videoHours: 22 },
  "10": { students: 1500, teachers: 10, lessons: 30, videoHours: 24 },
  "11": { students: 1550, teachers: 11, lessons: 32, videoHours: 26 },
  "12": { students: 1600, teachers: 12, lessons: 34, videoHours: 28 },
};

const _buildGeneratedCourses = () => {
  const out = {};
  if (typeof GRADE_LIST === 'undefined') return out;

  GRADE_LIST.forEach((g) => {
    // ۱-۶ دستی هستن، رد کن
    if (['1', '2', '3', '4', '5', '6'].includes(g.id)) return;

    const defaults = _DEFAULT_COURSE_META[g.id] || {
      students: 1200, teachers: 8, lessons: 24, videoHours: 18,
    };

    if (!curriculumNeedsField(g.id)) {
      // ۷-۹: ساده
      getSubjectsFor(g.id).forEach((s) => {
        const key = `${g.id}-${s.id}`;
        if (COURSE_DETAILS[key]) return; // اگه دستی تعریف شده، دست نزن
        out[key] = {
          grade: g.title,
          title: s.title,
          students: defaults.students + Math.floor(Math.random() * 200),
          teachers: defaults.teachers + Math.floor(Math.random() * 3),
          lessons: defaults.lessons,
          videoHours: defaults.videoHours,
          image: `/Books/${s.id}-${g.id}.jpg`,
        };
      });
    } else {
      // ۱۰-۱۲: با رشته
      FIELD_LIST.forEach((f) => {
        getSubjectsFor(g.id, f.id).forEach((s) => {
          const key = `${g.id}-${f.id}-${s.id}`;
          if (COURSE_DETAILS[key]) return;
          out[key] = {
            grade: g.title,
            field: f.id,
            fieldTitle: f.shortTitle,
            title: s.title,
            students: defaults.students + Math.floor(Math.random() * 300),
            teachers: defaults.teachers + Math.floor(Math.random() * 4),
            lessons: defaults.lessons,
            videoHours: defaults.videoHours,
            image: `/Books/${s.id}-${g.id}.jpg`,
          };
        });
      });
    }
  });

  return out;
};

// 🔽 CHANGED: merge خودکار با داده‌ی دستی
Object.assign(COURSE_DETAILS, _buildGeneratedCourses());

export default function CourseDetail() {
  const params = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);

  const rawGrade = params.grade;
  const rawSubject = params.subject;
  const rawField = params.field || null;

  const grade = curriculumNormalizeGrade(rawGrade) || rawGrade;
  const field = rawField ? (curriculumNormalizeField(rawField) || rawField) : null;
  const subject = rawSubject;

  // 🆕 آمار واقعی
  const [realStats, setRealStats] = useState({
    students: 0,
    teachers: 0,
    lessons: 0,
    videoHours: 0,
  });

  // 🆕 محاسبه‌ی خودکار آمار واقعی
  useEffect(() => {
    if (!grade || !subject) return;
    let cancelled = false;

    const compute = async () => {
      // ─── ۱. معلم‌ها + درس‌های یکتا + ساعت ویدیو از dataEngine ───
      let teachersCount = 0;
      const uniqueLessonIds = new Set();
      const lessonDurationById = {};

      try {
        const teachers = dataEngine.query.getTeachersForSubject(grade, subject, field);
        teachersCount = Array.isArray(teachers) ? teachers.length : 0;

        for (const t of teachers) {
          try {
            const bd = dataEngine.query.getBookData(grade, subject, t.folderName, field);
            for (const ch of bd?.chapters || []) {
              for (const ls of ch.lessons || []) {
                const lid = ls.legacyLessonId || ls._id;
                if (!lid) continue;
                uniqueLessonIds.add(lid);

                let lessonDur = 0;
                for (const step of ls.steps || []) {
                  lessonDur += Number(step.durationMinutes) || 0;
                }

                // بیشترین مدت یک درس بین همه‌ی معلمان
                if (!lessonDurationById[lid] || lessonDurationById[lid] < lessonDur) {
                  lessonDurationById[lid] = lessonDur;
                }
              }
            }
          } catch {}
        }
      } catch (e) {
        console.warn('[CourseDetail] teachers/lessons compute failed:', e);
      }

      let totalMinutes = 0;
      for (const lid in lessonDurationById) totalMinutes += lessonDurationById[lid];
      const videoHours = Math.round(totalMinutes / 60);

      // ─── ۲. دانش‌آموزان از سرور ───
      let studentCount = 0;
      try {
        const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';
        const res = await fetch(`${API_BASE}/lessonRecords`);
        if (res.ok) {
          const list = await res.json();
          if (Array.isArray(list)) {
            const userIds = new Set();
            for (const rec of list) {
              const uid = rec._userId || String(rec.id || '').replace(/^lesson-records-/, '');
              const data = rec.data || {};
              if (!uid || !data) continue;
              for (const r of Object.values(data)) {
                if (!r || !r.grade || !r.subject) continue;
                if (String(r.grade) !== String(grade)) continue;
                if (r.subject !== subject) continue;
                if (field && r.field && r.field !== field) continue;
                userIds.add(uid);
                break;
              }
            }
            studentCount = userIds.size;
          }
        }
      } catch (e) {
        console.warn('[CourseDetail] students fetch failed:', e);
      }

      if (!cancelled) {
        setRealStats({
          students: studentCount,
          teachers: teachersCount,
          lessons: uniqueLessonIds.size,
          videoHours,
        });
      }
    };

    compute();
    return () => { cancelled = true; };
  }, [grade, subject, field]);

  // تنظیمات رنگ‌ها (دقیقاً مشابه نسخه‌ی قبلی)
  const cardStyles = [
    { bg: "#ff727200", icon: "#000000", label: "#ffffff", sep: "#ffffff", value: "#FFFFFF" },
    { bg: "#00b89300", icon: "#000000", label: "#FFFFFF", sep: "#DFF6F0", value: "#FFFFFF" },
    { bg: "#fdcb6e00", icon: "#000000", label: "#ffffff", sep: "#ffffff", value: "#ffffff" },
    { bg: "#e1715500", icon: "#000000", label: "#FFFFFF", sep: "#FADBD8", value: "#FFFFFF" },
  ];

  useEffect(() => {
    if (!grade || !subject) {
      navigate("/books");
      setLoading(false);
      return;
    }

    // 🔽 CHANGED: تلاش چندگانه برای پیدا کردن داده
    let data = null;

    // ۱. اگه field صریح داده شده
    if (field) {
      data = COURSE_DETAILS[`${grade}-${field}-${subject}`] || null;
    }

    // ۲. بدون field (۱-۹ یا fallback)
    if (!data) {
      data = COURSE_DETAILS[`${grade}-${subject}`] || null;
    }

    // ۳. اگه پایه نیاز به field داشت ولی نداریم، اولین رشته‌ی موجود رو امتحان کن
    if (!data && curriculumNeedsField(grade)) {
      for (const f of FIELD_LIST) {
        const candidate = COURSE_DETAILS[`${grade}-${f.id}-${subject}`];
        if (candidate) {
          data = candidate;
          break;
        }
      }
    }

    if (data) {
      setCourse(data);
    } else {
      navigate("/books");
    }
    setLoading(false);
  }, [grade, subject, field, navigate]);

  if (loading) return <div className="course-detail-page loading">در حال بارگذاری...</div>;
  if (!course) return null;

const statsData = [
  { icon: "👥", label: "دانش‌آموزان", value: realStats.students.toLocaleString() },
  { icon: "👨‍🏫", label: "معلم‌ها", value: realStats.teachers.toLocaleString() },
  { icon: "📚", label: "درس‌ها", value: realStats.lessons.toLocaleString() },
  { icon: "🎬", label: "ساعت ویدیو", value: realStats.videoHours.toLocaleString() },
];

  return (
    <div className="course-detail-page">
      <div
        className="course-background"
        style={{ backgroundImage: `url(${course.image})` }}
      >
        <button className="back-btn" onClick={() => navigate("/books")}>
          <svg viewBox="0 0 24 24" width="24" height="24">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill="currentColor"/>
          </svg>
        </button>
        <div className="gradient-overlay"></div>
        <div className="course-info-container">
          <div className="course-info">
            <div className="grade-badge">{course.grade}</div>
            <h1 className="course-title">{course.title}</h1>
            <div className="divider-line"></div>
            <div className="stats-grid">
              {statsData.map((stat, index) => {
                const style = cardStyles[index % cardStyles.length];
                return (
                  <div
                    key={index}
                    className="stat-item1"
                    style={{ backgroundColor: style.bg }}
                  >
                    <span className="stat-icon" style={{ color: style.icon }}>
                      {stat.icon}
                    </span>
                    <span className="stat-label" style={{ color: style.label }}>
                      {stat.label}
                    </span>
                    <span className="stat-separator" style={{ color: style.sep }}>
                      :
                    </span>
                    <span className="stat-value" style={{ color: style.value }}>
                      {stat.value}
                    </span>
                  </div>
                );
              })}
            </div>

            <button
              className="start-learning-btn"
              onClick={() => {
                // 🔽 CHANGED: مسیر با field برای ۱۰-۱۲
                const basePath = field
                  ? `/course/${grade}/${field}/${subject}`
                  : `/course/${grade}/${subject}`;
                navigate(`${basePath}/videos`);
              }}
            >
              <span>🚀</span> شروع یادگیری
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}